import React, { useState, useEffect } from "react";
import logo from "../assets/logo.jpg";
import firebase from "../data/firebase";

const Agendamento = () => {
	const [email, setEmail] = useState("");
	const [token, setToken] = useState("");

	const [carregando, setCarregando] = useState(false);

	const [usuario, setUsuario] = useState("");

	const [agendado, setAgendado] = useState("");
	const [horarios, setHorarios] = useState([]);
	const [agendamento, setAgendamento] = useState("");
	const [horario, setHorario] = useState("")
	const login = () => {
		setCarregando(true);
		firebase.db
			.collection("usuarios")
			.doc(email.toLowerCase().trim())
			.get()
			.then((resposta) => {
				if (resposta.exists) {
					const user = resposta.data();

					if (user.token !== token) {
						alert(
							"Verifique se seu token está correto ou entre em contato imediatamente com acessibilidade@ufg.br"
						);
						setCarregando(false);
						return;
					}

					setUsuario(user);
					firebase
						.usuarioAgendado(user.email)
						.then((respostaAgendamento) => {
							if (respostaAgendamento)
								setAgendado(respostaAgendamento.data());
						});
					setCarregando(false);
				} else {
					alert(
						"Inscrição não localizada \nVerifique se seus dados estão corretos ou entre em contato imediatamente com acessibilidade@ufg.br"
					);
					setCarregando(false);
				}
			});
	};

	return (
		<main className="container col-md-4">
			{usuario ? (
				<>
					{agendado ? (
						<>
							<h1>{agendado.estudante}</h1>
							<div>
								Seu agendamento está confirmado para{" "}
								{agendado.data} às {agendado.hora}{" "}
							</div>
							{agendado.sala ? (
								<div>
									Acesse este link para ter acesso à sala de
									reuniões. Caso esteja utilizando um telefone
									móvel, você será redirecionado para baixar
									um aplicativo. Baixe e, após a instalação,
									clique novamente no link da sala para entrar
									na reunião.
									<p>
										<a href={`https://${agendado.sala}`}>
											{agendado.sala}
										</a>
									</p>
								</div>
							) : (
								<div>
									Acesse esta página posteriormente ou
									momentos antes do seu agendanto para ter
									acesso ao link da sala virtual onde a
									reunião acontecerá.
								</div>
							)}

							<div>
								{" "}
								Em caso de dúvidas ou se o link para a sala de
								reuniões não estiver disponível no momento
								agendado, entre em contato através do e-mail{" "}
								<a href="mailto:acessibilidade@ufg.br">
									acessibilidade@ufg.br
								</a>
							</div>
						</>
					) : (
						<form>
O periodo de agendamento foi encerrado! Agradecemos pelo seu interesse.
						</form>
					)}
				</>
			) : (
				<form
					onSubmit={(event) => {
						event.preventDefault();
						login();
					}}
				>
					<div
						style={{ margin: "0 auto" }}
						className="col-md-6 col-6"
					>
						<img className="img-fluid" src={logo} />
					</div>
					<div class="form-group">
						<label for="exampleInputEmail1">E-mail</label>
						<input
							onChange={(event) => setEmail(event.target.value)}
							type="email"
							class="form-control"
							id="exampleInputEmail1"
							aria-describedby="emailHelp"
							placeholder="E-mail institucional informado na inscrição"
							required
						/>
					</div>
					<div class="form-group">
						<label for="exampleInputPassword1">
							Token de acesso
						</label>
						<input
							onChange={(event) => setToken(event.target.value)}
							type="text"
							class="form-control"
							id="exampleInputPassword1"
							placeholder="6 primeiros dígitos do seu CPF (somente números)"
							required
						/>
					</div>
					{carregando ? (
						<button class="btn btn-primary" type="button" disabled>
							<span
								class="spinner-border spinner-border-sm"
								role="status"
								aria-hidden="true"
							></span>
							Aguarde...
						</button>
					) : (
						<button type="submit" class="btn btn-primary">
							Verificar
						</button>
					)}
				</form>
			)}
		</main>
	);
};

export default Agendamento;
